import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Menu } from '../../views/twig/components/Menu';
/*(new Carousel()).init();
(new Collapse()).init();
(new Demo()).init();
(new Dropdown()).init();*/
(new LazyLoader()).init();
/*(new ScrollSpy()).init();*/
(new Menu()).init();
